// Utils
// Types
import type { GetStaticProps, NextPage } from 'next'
// Components
import Head from 'next/head'
import type { FC } from 'react'

import ProjectHeader from '../../components/molecules/projects/ProjectHeader'
import { Post } from '../../types/hashnode'
// Content
import { getPost } from '../../utils/hashnode'

interface Props {
    contractAddress: string
    article: Post
}

const MiniDegens: FC<Props> = ({ article }) => {
    return (
        <article className="prose mx-auto max-w-2xl dark:prose-invert">
            <ProjectHeader
                title="Codefolio"
                category="Portfólio"
                logo="/images/projects/code.png"
                tags={['React', 'Next.js', 'Tailwind', 'Node.js', 'NestJS']}
                url="https://github.com/JairRodrigue/Codefolio"
            />

            <p>
                Codefolio é uma plataforma web moderna e profissional onde programadores
                podem criar currículos interativos, apresentar seus projetos e publicar
                conteúdos, compartilhando seu portfólio com empresas por meio de uma
                página pública personalizada.
            </p>

            <h3>Links</h3>

            <ul>
                <li>
                    <a
                        href="https://github.com/JairRodrigue/Codefolio"
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        GitHub
                    </a>
                </li>
                <li>
                    <a
                        href="https://github.com/JairRodrigue/Codefolio/releases"
                        target={'_blank'}
                        rel="noopener noreferrer"
                    >
                        Releases
                    </a>
                </li>
            </ul>

            <h3 className="mt-10 text-xl font-semibold">Veja a demo do projeto</h3>

            <p className="mb-4 mt-2 max-w-2xl text-sm text-gray-400">
                O projeto ainda está em construção. O vídeo abaixo mostra um mockup do
                front-end, enquanto o desenvolvimento do back-end está em andamento.
            </p>

            <div className="not-prose my-6 max-w-3xl overflow-hidden rounded-xl border border-white/10 bg-black/20 shadow-lg">
                <video
                    src="/images/projects/demo.mp4"
                    controls
                    preload="metadata"
                    className="h-auto w-full rounded-xl"
                >
                    Seu navegador não suporta reprodução de vídeo.
                </video>
            </div>
        </article>
    )
}

const MiniDegensPage: NextPage<Props> = (props) => (
    <div className="container mx-auto">
        <Head>
            <title>Codefolio</title>
        </Head>

        <MiniDegens {...props} />
    </div>
)

export default MiniDegensPage

export const getStaticProps: GetStaticProps<Props> = async () => {
    return {
        props: {
            contractAddress: '0x24F6328cdDDdad9475c9a3DC2675b5ef851A7C5E',
            article: await getPost('6968db8b1065d3643b0c86fe'),
        },
    }
}
